import type { GetStaticProps } from 'next';

import { makeStaticPropsRequest } from '../modules/page-info';
import { makePage } from '../modules/page-info/page';
import { makePagePropsProvider } from '../modules/page-info/page-props-provider';
import type { PageProps } from '../modules/page-info/types';

export const getStaticProps: GetStaticProps<PageProps> = makeStaticPropsRequest(
  '/network-operator-standards',
  'No network operator standards page entry found'
);

const PageComponent = makePage({ pageTitle: 'Network operator standards' });
const NetworkOperatorStandardsPage = makePagePropsProvider<typeof getStaticProps>(PageComponent);
export default NetworkOperatorStandardsPage;
